import { useState } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function Emails() {
  const [action, setAction] = useState('create'); // 'create' | 'delete'
  const [id, setId] = useState('');
  const [language, setLanguage] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setMessage('');
    if (!id || !language) {
      setMessage('Please provide both ID and language.');
      return;
    }

    try {
      if (action === 'create') {
        if (!name || !email) {
          setMessage('Please provide name and email.');
          return;
        }

        const emailData = {
          emailId: { id: Number(id), language },
          name,
          email,
        };

        const savedEmail = await sendApiRequest('POST', '/admin/emails', emailData);
        setMessage(`Email saved: ${savedEmail?.name ?? name} (${savedEmail?.emailId?.language ?? language})`);
      } else {
        await sendApiRequest('DELETE', `/admin/emails/email?id=${id}&language=${language}`);
        setMessage(`Email with ID ${id} (${language}) deleted.`);
      }

      // reset fields
      setId('');
      setLanguage('');
      setName('');
      setEmail('');
    } catch (error) {
      setMessage(`${error?.message ?? 'Request failed'}`);
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Create / Update Email' : 'Delete Email'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Create / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <>
          <div className="editing-panel__field">
            <label>Email ID</label>
            <input
              type="number"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="Enter email ID"
            />
          </div>

          <div className="editing-panel__field">
            <label>Language</label>
            <input
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              placeholder="e.g. en or no"
            />
          </div>
        </>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field">
              <label>Name / Label</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Taxi, Support, Emergency"
              />
            </div>

            <div className="editing-panel__field">
              <label>Email</label>
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="e.g. support@company.com"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Email' : 'Save Email'}
      message={message}
    />
  );
}
